import React, { Component } from 'react';
import Loader from "../../utils/Loader";
import { ToastContainer } from "react-toastify";
import Footer from "../../common_components/Footer";
import Header from "../../common_components/Header";
import { withRouter } from "../../utils/withRouter";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import { getWebsiteBlogDetails_action } from '../../actions/staticAction/static_action'
import { BASE_URL, toastError } from '../../utils/constants';
import purify from 'dompurify'
import { Modal } from 'react-bootstrap';
// 
class BlogDetails extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            title: '',
            Content: '',
            Name: '',
            Designation: '',
            isSocial: false
        }
        this.slider3Ref = React.createRef()
    }
    componentDidMount() {
        window.scrollTo(0, 0)
        this.getBlogDetails()
    }

    getBlogDetails() {
        const { } = this.state
        this.setState({ isLoading: true })
        var Id = this.props.location.pathname.split('/blogDetails/')[1]
        this.props
            .getWebsiteBlogDetails_action(Id)
            .then((data) => {
                if (data.error != 1) {
                    if (data.data != '') {
                        this.setState({
                            title: data.data[0]['Title'],
                            Content: data.data[0]['Details'],
                            Name: data.data[0]['Name'],
                            Designation: data.data[0]['Designation'],
                        })
                    } else {
                        this.props.navigate('/')
                    }
                    this.setState({
                        isLoading: false,
                    })

                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    sanitizeAndResizeImages = (htmlContent) => {
        const div = document.createElement("div");
        div.innerHTML = purify.sanitize(htmlContent);

        // Resize all images
        div.querySelectorAll("img").forEach((img) => {
            img.style.width = "450px";  // Make image responsive within the fixed box
            img.style.height = "auto"; // Maintain aspect ratio
            img.style.objectFit = "cover"; // Ensure full coverage
        });
        div.querySelectorAll("span").forEach((span) => {
            span.style.display = "inline-block";
            span.style.lineHeight = "23px";
        });

        return div.innerHTML;
    };


    shareOnWhatsApp = () => {

        const path = this.props.location.pathname
        const Url = BASE_URL.split('/api')[0] + '/#' + path

        const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(Url)}`;
        window.open(whatsappUrl, "_blank");
    };

    shareOnTwitter = () => {
        const path = this.props.location.pathname
        const Url = BASE_URL.split('/api')[0] + '/#' + path

        const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(Url)}`;
        window.open(twitterUrl, "_blank");
    };


    shareOnFacebook = () => {
        const path = this.props.location.pathname;
        const Url = BASE_URL.split('/api')[0] + '/#' + path;
        console.log("Url--->", Url)
        const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(Url)}`;
        window.open(facebookUrl, "_blank");
    };

    shareOnMessenger = () => {
        const path = this.props.location.pathname;
        const Url = BASE_URL.split('/api')[0] + '/#' + path;

        const messengerUrl = `https://www.messenger.com/new?text=${encodeURIComponent(Url)}`;
        window.open(messengerUrl, "_blank"); // Opens Messenger with pre-filled text
    };


    shareOnInstagram = () => {
        const path = this.props.location.pathname;
        const Url = BASE_URL.split('/api')[0] + '/#' + path;

        const message = `Check this out:\n${Url}\nAnother Link: https://example.com`;

        const instaUrl = `https://www.instagram.com/direct/new/`;

        window.open(instaUrl, "_blank"); // Opens Instagram DM page
    }

    shareOnLinkedIn = () => {
        const path = this.props.location.pathname;
        const Url = BASE_URL.split('/api')[0] + '/#' + path;

        const linkedInUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(Url)}`;

        console.log("LinkedIn Share URL:", linkedInUrl); // Debugging output
        window.open(linkedInUrl, "_blank");
    };

    render() {
        const { isLoading, Content, title, Name, Designation, isSocial } = this.state

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                {/* <ToastContainer />. */}
                <Header />


                <div
                    className="breadcrumb-wrapper bg-cover"
                    style={{ backgroundImage: 'url("assets/img/breadcrumb.jpg")' }}
                >
                    <div className="border-shape">
                        <img src="assets/img/element_1.png" alt="shape-img" />
                    </div>
                    <div className="line-shape">
                        <img src="assets/img/line-element.png" alt="shape-img" />
                    </div>
                    <div className="container">
                        <div className="page-heading">
                            <h1 className="wow fadeInUp" data-wow-delay=".3s">
                                Blog Details
                            </h1>
                            <ul className="breadcrumb-items wow fadeInUp" data-wow-delay=".5s">
                                <Link to='/'><li>Home </li></Link>
                                <li>
                                    <i className="fa fa-chevron-right" />
                                </li>
                                <li>Blog Details</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="row py-4" >
                    <div class="col-2" > </div>
                    <div class="col-8" >
                        <div class="blog-card-body">
                            <h3><a style={{ color: '#744587' }} >{title}</a></h3>
                            <div class="author-meta">
                                <div class="fancy-box style1" style={{ justifyContent: 'space-between' }}>
                                    <div class="item ">
                                        <h6 >{Name}</h6>
                                        <p>{Designation}</p>
                                    </div>
                                    {/* <p>
                                        <a class="link-btn style2"
                                            onClick={() => this.setState({ isSocial: true })}
                                        >Share <i class="fa fa-share"></i></a>
                                    </p> */}
                                </div>
                            </div>
                        </div>
                        <div class="blog-card-thumb">
                            <p className="m-1" >
                                <span dangerouslySetInnerHTML={{ __html: this.sanitizeAndResizeImages(Content) }} />
                            </p>
                        </div>
                    </div>
                    <div class="col-2" > </div>
                </div>
                <Footer />
                <Modal show={isSocial} size="md" onHide={() => this.setState({ isSocial: false })}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <h5 className="modal-title" id="staticBackdropLabel">
                                Blog Share
                            </h5>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="pb-2 pt-2"
                        style={{
                            backgroundColor: '#744587',
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                        }}
                    >
                        <div className="container text-center p-4">
                            <div class="gt-social style2">
                                <a target='blank' onClick={() => this.shareOnWhatsApp()}><i class="fa fa-whatsapp"></i></a>
                                <a target='blank' onClick={() => this.shareOnFacebook()}><i class="fa fa-facebook-f"></i></a>
                                <a target='blank' onClick={() => this.shareOnMessenger()}><img src='assets/img/messenger.png' height={14} width={18} style={{ marginBottom: '3px' }}></img></a>
                                <a target='blank' onClick={() => this.shareOnLinkedIn()}><i class="fa fa-linkedin"></i></a>
                                <a target='blank' onClick={() => this.shareOnTwitter()}><i class="fa fa-twitter"></i></a>
                                <a target='blank' onClick={() => this.shareOnInstagram()}><i class="fa fa-instagram"></i></a>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </>
        )

    }
}
// ReactDOM.render(<Homepage />, document.querySelector('.demo-carousel'))

export default withRouter(connect(null, { getWebsiteBlogDetails_action })(BlogDetails));